import { Link } from "react-router-dom";
import { Phone, MessageSquare, Printer, Mail, MapPin, Clock } from "lucide-react";
import { BOOKING_URL, PHONE_DISPLAY, PHONE_TEL, FAX_DISPLAY, EMAIL, ADDRESS_LINE1, ADDRESS_LINE2, MAPS_URL, HOURS } from "../data/site";
import { SocialLinks } from "../components/SocialLinks";
import { trackContact, trackSchedule } from "../lib/tracking";

const ITEMS = [
  { id: "phone", icon: Phone, label: "Phone", text: PHONE_DISPLAY, href: `tel:${PHONE_TEL}` },
  { id: "text", icon: MessageSquare, label: "Text", text: PHONE_DISPLAY, href: `sms:${PHONE_TEL}` },
  { id: "fax", icon: Printer, label: "Fax", text: FAX_DISPLAY },
  { id: "email", icon: Mail, label: "Email", text: EMAIL, href: `mailto:${EMAIL}` },
  { id: "address", icon: MapPin, label: "Address", text: `${ADDRESS_LINE1}, ${ADDRESS_LINE2}`, href: MAPS_URL },
  { id: "hours", icon: Clock, label: "Hours", text: HOURS },
];

const Item = ({ it }) => {
  const body = (
    <>
      <it.icon size={18} strokeWidth={1.25} className="text-neutral-950" />
      <p className="kicker mt-5">{it.label}</p>
      <p className="font-display mt-2 text-xl leading-snug text-neutral-950 md:text-2xl">{it.text}</p>
    </>
  );
  const cls = "block bg-white p-8 transition-colors";
  if (!it.href) return <div className={cls} data-testid={`contact-us-${it.id}`}>{body}</div>;
  const ext = it.href.startsWith("http");
  return <a href={it.href} target={ext ? "_blank" : undefined} rel="noreferrer" onClick={trackContact} className={`${cls} hover:bg-neutral-100`} data-testid={`contact-us-${it.id}`}>{body}</a>;
};

export default function ContactUs() {
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(`Lux Veritae Skin Spa, ${ADDRESS_LINE1}, ${ADDRESS_LINE2}`)}&output=embed`;
  return (
    <main data-testid="contact-us-page">
      <section className="bg-neutral-950 px-6 py-24 text-center text-white md:py-32">
        <p className="text-[11px] uppercase tracking-[0.35em] text-neutral-400">Lux Veritae Skin Spa · Scottsdale</p>
        <h1 className="font-display mt-4 text-5xl font-light sm:text-6xl lg:text-7xl" data-testid="contact-us-title">Contact Us</h1>
        <p className="mx-auto mt-6 max-w-md text-base font-light text-neutral-300">Call, text or visit. Our concierge will be glad to help.</p>
        <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
          <a href={BOOKING_URL} target="_blank" rel="noreferrer" onClick={trackSchedule} className="btn-ghost-light" data-testid="contact-us-book-btn">Book Online</a>
          <Link to="/contact" className="btn-ghost-light" data-testid="contact-us-consult-btn">Request a Consultation</Link>
        </div>
      </section>
      <section className="bg-[hsl(var(--stone))] py-20 md:py-28">
        <div className="mx-auto max-w-[1200px] px-4 md:px-8">
          <div className="grid gap-px bg-neutral-300 sm:grid-cols-2 lg:grid-cols-3">
            {ITEMS.map((it) => <Item key={it.id} it={it} />)}
          </div>
          <div className="mt-12 aspect-[4/3] w-full overflow-hidden bg-neutral-200 md:aspect-[21/9]">
            <iframe title="Map to Lux Veritae Skin Spa" src={mapSrc} className="h-full w-full grayscale" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="contact-us-map" />
          </div>
          <div className="mt-12 flex justify-center bg-neutral-950 py-8"><SocialLinks /></div>
        </div>
      </section>
    </main>
  );
}
